const boundaries = [
  { title: '判断', desc: '不对信息进行好坏、风险或可行性判断' },
  { title: '建议', desc: '不提供任何建议或决策支持' },
  { title: '交易', desc: '不参与任何交易、撮合或协商行为' },
  { title: '金融', desc: '不涉及金融、借贷、投资等业务' },
]

export default function BoundarySection() {
  return (
    <section className="bg-gray-900 py-12 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-orange-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-6 relative">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <span className="text-xs font-medium text-orange-400 uppercase tracking-wider">平台边界</span>
            <h2 className="text-2xl font-bold text-white mt-2">我们不做什么</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {boundaries.map((item, index) => (
            <div key={index} className="group">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10 hover:border-orange-500/30 transition-colors h-full">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-2xl font-bold text-orange-500">不</span>
                  <span className="text-sm font-medium text-white">{item.title}</span>
                </div>
                <p className="text-xs text-gray-400 leading-relaxed">{item.desc.slice(1)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
